<template>
  <b-row>
    <b-col md="12">
      <b-card v-if="$route.params.id">
        <b-row class="align-items-center">
          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">{{$t('application_number')}}</h6>
              <small>#{{ GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.id }}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">{{$t('general.created_at_application')}}</h6>
              <small>{{$dayjs(GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.created_at).format("DD.MM.YYYY")}}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">{{$t('author')}}</h6>
              <div class="d-flex">
                <small v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.author">{{
                  GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.author.first_name
                }}</small>
                <small
                  v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.author"
                  class="ml-50"
                  >{{ GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.author.last_name }}</small
                >
              </div>
            </div>
          </b-col>

          <b-col class="col-md-3">
            <div class="flex_column align-items-center">
              <h6 class="font-weight-bolder">{{$t('status')}}</h6>
              <b-badge
                v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status"
                :variant="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.color"
              >
                {{ GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.name }}
              </b-badge>
            </div>
          </b-col>
          <b-col v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status" class="col-md-3">
            <div
              class="d-flex flex-wrap justify-content-end align-items-center"
            >
              <template
                v-for="(item, index) in GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status
                  .change_to"
              >
                <b-button
                  :key="index"
                  v-if="checkButtonPermission([...item.roles, 'admin']) && checkAndHideIfNeeded()"
                  size="sm"
                  class="ml-50"
                  style="margin: 3px 0"
                  :variant="item.color"
                  :disabled="checkAndDisableStatusIfNeeded(item)"
                  @click="onChangeStatus(GET_ONE_APPLICATION_FOR_BRIGADE_WORKS, item)"
                >
                  {{ item.name }}
                </b-button>
              </template>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col cols="9">
      <b-card>
        <b-tabs>
          <b-tab active :title="$t('applications')">
            <div class="d-flex flex-wrap">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pb-50
                  w-100
                "
              >
                <div>

                  <h6 class="mb-0 font-weight-bolder" v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.brigade && 
                  GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.brigade.title">{{$t('brigade')}}: {{GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.brigade.title}}</h6>

                  <h6 class="mb-0 font-weight-bolder">{{$t('date')}}: {{$dayjs(GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_date).format("DD.MM.YYYY")}}</h6>
                  
                  <h6 class="mb-0 font-weight-bolder" v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_place &&
                  GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_place.title && GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_place.title[$i18n.locale]">
                  {{$t('place_of_work')}}: {{GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_place.title[$i18n.locale]}}</h6>
                  
                  <h6 class="mb-0 font-weight-bolder" v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.fine &&
                  GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.fine">
                  {{$t('fine')}}: {{ $_formatPriceMixin(GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.fine) }}</h6>

                </div>



                
                <div class="d-flex">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    size="sm"
                    class="d-flex align-items-center ml-50"
                    variant="success"
                    @click="showModalAddFiles()"
                    :disabled="!isMounted"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      size="18"
                      class="mr-50"
                    />
                    {{$t('watch_files')}}
                  </b-button>
                </div>
              </div>

              <b-table
                class="table-bordered border"
                :fields="fields"
                :items="items"
                show-empty
                hover
                responsive
                :empty-text="$t('empty_text')"
              >
                <template #row-details="row">
                  <span v-if="row.item && row.item.created_comment">
                    {{$t('contact.comment')}}: {{ row.item.created_comment }}
                  </span>
                </template>

                <template #head()="props">
                  <span>{{ $t(props.label) }}</span>
                </template>

                <template #cell(index)="{ index }">
                  <span>{{ index + 1 }}</span>
                </template>

                <template #cell(brigade)="props">
                  <span v-if="props && props.item && props.item.brigade">{{ props.item.brigade.title }}</span>
                </template>

                <template #cell(work_type_category)="props">
                  <span v-if="props.item && props.item.work_type && props.item.work_type.category && props.item.work_type.category.title">
                    {{ props.item.work_type.category.title[$i18n.locale] }}
                  </span>
                </template>

                <template #cell(work_type)="props">
                  <span v-if="props.item && props.item.work_type && props.item.work_type && props.item.work_type.title">
                    {{ props.item.work_type.title[$i18n.locale] }}
                  </span>
                </template>
             
                <template #cell(unity)="props">
                  <span v-if="props.item && props.item.work_type && props.item.work_type.unity && props.item.work_type.unity.title">{{ props.item.work_type.unity.title }}</span>
                </template>

                <template #cell(price_for_each)="{ value }">
                  {{ $_formatPriceMixin(value) }}
                </template>

                <template #cell(workload)="props">
                  <span>{{ props.item.workload }}</span>
                </template>
              
                <template #cell(total_amount)="props">
                  <span>{{ $_formatPriceMixin(props.item.workload * props.item.price_for_each) }}</span>
                </template>

                <template #cell(fine)="props">
                  <span>{{ $_formatPriceMixin(props.item.fine) }}</span>
                </template>
                
                <template #cell(total_partial_payments)="props">
                  <span>{{ $_formatPriceMixin(props.item.total_partial_payments) }}</span>
                </template>

                <!-- <template #cell(created_comment)="props">
                  <span>{{ props.item.created_comment }}</span>
                </template> -->

                <template #cell(actions)="props">
                 
                  <b-button size="sm" @click="props.toggleDetails" class="mr-2 mb-50 mt-50 mb-50">
                    {{ props.detailsShowing ? $t('general.close') : $t('general.show') }}
                    {{$t('contact.comment2')}}
                  </b-button>
                 
                  <b-button size="sm" @click="showPartialPaymentsHistoryModal(props.item)" class="mr-2 mb-50 mt-50 mb-50" variant="info"
                  v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.unique_name == 'partial_payment_brigades'">
                    {{$t('show_payed_sums')}}
                  </b-button>

                  <b-button size="sm" @click="showPartialPaymentModal(props.item)" variant="success" class="mr-2 mt-50 mb-50"
                   v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.unique_name == 'partial_payment_brigades'">
                    {{$t('pay')}}
                  </b-button>

                </template>
              </b-table>

              <div class="mt-2 mb-2 d-flex justify-content-between flex-column">
                <div class="d-flex">
                  <h6 class="mb-0 font-weight-bolder">{{$t('very_total_amount')}}:</h6>
                  <small class="ml-50">
                    {{ getTotalSum() }}
                  </small>
                </div>
                <div class="d-flex">
                  <h6 class="mb-0 font-weight-bolder">{{$t('object')}}:</h6>
                  <small
                    v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS &&
                     GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.storage && 
                     GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.storage.rc_object"
                    class="ml-50"
                  >
                    {{ GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.storage.rc_object }}
                  </small>
                </div>
              </div>

            </div>
          </b-tab>
        </b-tabs>

      </b-card>


      <div class="text-right ">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="d-flex align-items-center"
          variant="secondary"
          @click="$router.back()"
        >
          <feather-icon icon="ArrowLeftIcon" size="18" />
          {{ $t("back") }}
        </b-button>
      </div>
    </b-col>



    <b-col cols="3">
      <b-card>
        <div class="d-flex flex-wrap">
          <app-timeline class="h-100 w-100">
            <app-timeline-item
              v-for="item in GET_APPLICATION_STATUS_TIMELINE_BY_ID"
              :key="item.id"
              :title="item.to_status.full_name + ' #' + item.object_id"
              :subtitle="item.author.first_name + item.author.last_name"
              :comment="(item.description ? item.description : '')"
              :icon="item.to_status.icon"
              :time="$dayjs(item.created_at).format('DD.MM.YYYY, HH:mm')"
              :variant="item.to_status.color"
              :author="true"
            />
          </app-timeline>
        </div>
      </b-card>
    </b-col>



    <b-modal
      ref="makePartialPayment"
      cancel-variant="outline-secondary"
      :ok-title="$t('pay')"
      :cancel-title="$t('cancel')"
      centered
      size="md"
      no-close-on-backdrop
      :title="$t('partial_payment')"
      @ok="onSubmitPartialPayment($event)"
    >
      <div>
        <validation-observer ref="makePartialPaymentObserver">
          <b-form-group :label="$t('sum')">
            <validation-provider
              #default="{ errors }"
              :name="$t('sum')"
              rules="required"
            >
              <b-form-input
                v-model="partialPaymentSum"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </div>
    </b-modal>



    <b-modal
      ref="confirmOrRefuse"
      cancel-variant="outline-secondary"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      centered
      size="md"
      no-close-on-backdrop
      :title="$t('do_you_really_want') + ' ' + $t('refuse_this_application')"
      @ok="onStatusChangedAndSaved($event)"
    >
      <div>
        <validation-observer ref="confirmOrRefuseObserver">
          <b-form-group :label="$t('contact.comment')">
            <validation-provider
              #default="{ errors }"
              :name="$t('contact.comment')"
              rules="required"
            >
              <b-form-textarea
                v-model="statusComment"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </div>
    </b-modal>
  


  
    <b-modal
      ref="supervisorCommentAndFine"
      cancel-variant="outline-secondary"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      centered
      size="md"
      no-close-on-backdrop
      :title="$t('do_you_really_want') + ' ' + $t('submit_this_application_for_confirmation_supervisor_with_comment_and_fine')"
      @ok="onStatusChangedAndSaved2($event)"
    >
      <div>
        <validation-observer ref="supervisorCommentAndFineObserver">
          <b-form-group :label="$t('fine')">
            <validation-provider
              #default="{ errors }"
              :name="$t('fine')"
              rules="required"
            >
              <b-form-input
                v-model="fine"
                type="text"
                @input="formatPrice(fine, 'fine')"
                onkeypress="return /[0-9,/.]/i.test(event.key)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group :label="$t('contact.comment')">
            <validation-provider
              #default="{ errors }"
              :name="$t('contact.comment')"
              rules="required"
            >
              <b-form-textarea
                v-model="statusComment2"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </div>
    </b-modal>


    <addFilesModal1 :type="addFilestype"/>
    <seeProductsModal :seeProducts="seeProducts"></seeProductsModal>

  </b-row>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BRow,
  BTable,
  VBTooltip,
  BTabs,
  BTab,
  BFormGroup,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

import priceFormatMixin from "@/mixins/priceFormatMixin";
import { getUserData } from "@/auth/utils";
import check from "@/mixins/check";
import loader from "@/mixins/loader";
import Ripple from "vue-ripple-directive";
import { required } from "@core/utils/validations/validations";
import addFilesModal1 from './components/modals/addFilesModal1.vue'
import seeProductsModal from './components/modals/seeProductsModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    BCard,
    BBadge,
    BTabs,
    BTab,
    BFormGroup,
    BFormInput,
    BFormTextarea,

    AppTimeline,
    AppTimelineItem,

    AppCollapse,
    AppCollapseItem,

    ValidationObserver,
    ValidationProvider,

    addFilesModal1,
    seeProductsModal,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  mixins: [priceFormatMixin, check, loader],
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION START ===============
      required,
      userData: {},
      fine: '',
      statusComment: '',
      statusComment2: '',
      statusDeniedOrWaiting: '',
      addFilestype: 'add',
      isMounted: false,
      partialPaymentItem: {},
      partialPaymentSum: '',
      seeProducts: [],
      fields: [
        {
          label: "№",
          key: "index",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "reference.categoriya",
          key: "work_type_category",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "job_type",
          key: "work_type",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "unit_of_measurement",
          key: "unity",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "price_for_unit_of_measurement",
          key: "price_for_each",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "workload",
          key: "workload",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "total_amount",
          key: "total_amount",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "5%" },
        },
      ],
      items: []
      // ===============  PRIMARY_DATA_SECTION END ===============
    };
  },
  computed: {
    ...mapGetters("application", [
      "GET_ONE_APPLICATION_FOR_BRIGADE_WORKS",
      "GET_APPLICATIONS_MATERIAL_ID",
      "GET_APPLICATION_STATUS_TIMELINE_BY_ID",
    ]),

    
  },
  async mounted() {
    // await this.$_loaderStart();
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh();
    // ===============  PRIMARY_REQUESTS_SECTION END ===============

    this.userData = getUserData();
    this.isMounted = true
  },
  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("application", [
      "FETCH_ONE_APPLICATION_FOR_BRIGADE_WORKS",
      "FETCH_APPLICATIONS_MATERIAL_ID",
      "UPDATE_APPLICATION_MATERIAL",
      "UPDATE_PATCH_APPLICATION_FOR_BRIGADE_WORKS",
      "UPDATE_APPLICATION_MATERIAL_MOVEMENT",
      "FETCH_APPLICATION_STATUS_TIMELINE_BY_ID",
      "CREATE_PATCH_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS",
    ]),


    

    



    getTotalSum(){
      let total_sum = 0
      this.items.forEach((elem) => {
        total_sum = total_sum + (elem.workload * elem.price_for_each)
      })
      total_sum = this.formatPrice(total_sum, 'currency')
      return total_sum
    },





    // ===============  REFRESH_SECTION START ===============
    async refresh() {
      await this.FETCH_ONE_APPLICATION_FOR_BRIGADE_WORKS({id: this.$route.params.id})
        .then(async () => {

          if(this.fields.length < 9 && this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.unique_name == 'partial_payment_brigades'){
            let a = this.fields.pop()
            this.fields.push({
              label: "payed",
              key: "total_partial_payments",
              thClass: "text-center",
              tdClass: "text-center",
            })
            this.fields.push(a)
          }


          this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_types.forEach((elem1) => {
            let total_partial_payments = 0
            elem1.partial_payments.forEach((elem2) => {
              total_partial_payments += elem2.amount
            })
            elem1.total_partial_payments = total_partial_payments 
          })


          this.items = this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_types.map((elem) => {
            return {
              id: elem.id,
              created_comment: elem.created_comment,
              price_for_each: elem.price_for_each,
              workload: elem.workload,
              work_type: elem.work_type,
              brigade: this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.brigade,
              total_partial_payments: elem.total_partial_payments
            }
          })

          await this.FETCH_APPLICATION_STATUS_TIMELINE_BY_ID({
            id: this.$route.params.id,
            params: {
              content_type_model: "requirements_b",
              object_id: this.$route.params.id,
            },
          });

        })
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            // this.$router.push("/applications/material");
          }
        });
    },
    // ===============  REFRESH_SECTION START ===============









    // ========================= SHOW_MODALS END =========================
    showModalAddFiles(id){
      this.addFilestype = 'show'
      this.$bvModal.show('addFilesModal1')
    },
    showPartialPaymentModal(item){
      this.partialPaymentItem = item
      this.$refs['makePartialPayment'].show()
    },
    showPartialPaymentsHistoryModal(item){
      let element = this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_types.find((a) => a.id == item.id)
      this.seeProducts = element.partial_payments
      this.$bvModal.show('seeProductsModal')
    },
    // ========================= SHOW_MODALS END =========================










    // ===============  CHECK_AND_DISABLE_SECTION START ===============
    checkAndDisableStatusIfNeeded(item) {
      if (item.unique_name == "closed") {
        let status = false;
        this.GET_APPLICATIONS_MATERIAL_ID.objects.forEach((elem) => {
          if (elem.count > 0) {
            status = true;
          }
        });
        return status;
      }
    },
    checkAndHideIfNeeded(){
      console.log(this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS)
      let status = true
      if(this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.unique_name == "partial_payment_brigades"){
        this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_types.forEach((elem) => {
          elem.total_price = elem.workload * elem.price_for_each 
          if(elem.total_price != elem.total_partial_payments){
            status = false
          }
        })
      }
      return status
    },
    // ===============  CHECK_AND_DISABLE_SECTION START ===============











    // ===============  FORMAT_PRICE_SECTION START ===============
    formatPrice(value, type) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);

        if (type == "fine") {
          this.fine = currency;
        }else if(type == 'currency'){
          return currency
        }
      }
      return 0;
    },
    // ===============  FORMAT_PRICE_SECTION END ===============













    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitPartialPayment(){
        this.$refs.makePartialPaymentObserver.validate().then(async success => {
          if (!success) return;



          if(this.fields.length < 9){
            let a = this.fields.pop()
            this.fields.push({
              label: "payed",
              key: "total_partial_payments",
              thClass: "text-center",
              tdClass: "text-center",
            })
            this.fields.push(a)
          }


          // let userData = localStorage.getItem('userDataWAREHOUSE') ? localStorage.getItem('userDataWAREHOUSE') : {storage: null}
          await this.CREATE_PATCH_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS({amount: this.partialPaymentSum.toString().replace(/,/g, ""), 
          payed_to: this.partialPaymentItem.id}).then(async () => {


              await this.FETCH_ONE_APPLICATION_FOR_BRIGADE_WORKS({id: this.$route.params.id})
              .then(async () => {

                this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_types.forEach((elem1) => {
                  let total_partial_payments = 0
                  elem1.partial_payments.forEach((elem2) => {
                    total_partial_payments += elem2.amount
                  })
                  elem1.total_partial_payments = total_partial_payments 
                })


                this.items = this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.work_types.map((elem) => {
                  return {
                    id: elem.id,
                    created_comment: elem.created_comment,
                    price_for_each: elem.price_for_each,
                    workload: elem.workload,
                    work_type: elem.work_type,
                    brigade: this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.brigade,
                    total_partial_payments: elem.total_partial_payments
                  }
                })


              })
              .catch((err) => {
                if (
                  err &&
                  err.response &&
                  err.response.status &&
                  err.response.status == 404
                ) {
                  // this.$router.push("/applications/material");
                }
              });


          });
        });
    },
    // ===============  ON_SUBMIT_SECTION END ===============















    // ===============  ON_CHANGE_STATUS_SECTION START ===============
    onChangeStatus(props, item) {
      const status = {
        in_consideration_pto_b: this.$t('submit_this_application_for_review_on_pto'),
        confirmation_supervisor_b: this.$t('submit_this_application_for_confirmation_supervisor'),
        awaiting_paid_b: this.$t('switch_to_pending_payment_status'),
        paid_brigades: this.$t("switch_to_paid_status2"),


        confirmed: this.$t('confirm_this_application'),
        denied_brigades: this.$t('refuse_this_application'),
        purchase: this.$t('create_a_purchase_requisition'),
        closed: this.$t('close2'),
        new_requirement_brigades: this.$t('switch_to_new_status'),
        in_financiers_confirmation_brigades: this.$t('submit_this_application_for_financiers_confirmation'),
        partial_payment_brigades: this.$t('switch_to_partial_payment_status'),
      };


      this.statusId = props.id
      if(item.unique_name == 'denied_brigades'){
        this.$refs['confirmOrRefuse'].show()
        this.statusDeniedOrWaiting = 'denied_brigades'
      }else if(item.unique_name == 'confirmation_supervisor_with_fine'){
        this.$refs['supervisorCommentAndFine'].show()
        this.statusDeniedOrWaiting = 'confirmation_supervisor_with_fine'
      }else{
        this.$bvModal
          .msgBoxConfirm(
            this.$t('do_you_really_want') + ` ${status[item.unique_name]} ?`,
            {
              title: this.$i18n.t('attention'),
              size: "sm",
              okVariant: item.color,
              okTitle: this.$t('yes'),
              cancelTitle: this.$t('no'),
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then(async (value) => {
            if (!value) return;
            await this.UPDATE_PATCH_APPLICATION_FOR_BRIGADE_WORKS({
              status_unique: item.unique_name,
              id: props.id,
            }).then(async () => {
              await this.refresh();
            });
          });
      }
    },
    async onStatusChangedAndSaved(bvModalEvt){
      bvModalEvt.preventDefault();
      await this.$refs.confirmOrRefuseObserver.validate().then(async (success) => {
        if (!success) return;
        await this.UPDATE_PATCH_APPLICATION_FOR_BRIGADE_WORKS({
          status_unique: this.statusDeniedOrWaiting,
          status_description: this.statusComment,
          id: this.statusId,
        }).then(() => {
          this.refresh();
          this.$_okToast("success");
          this.$refs.confirmOrRefuse.hide()
        });
      })
    },
    async onStatusChangedAndSaved2(bvModalEvt){
      bvModalEvt.preventDefault();
      await this.$refs.supervisorCommentAndFineObserver.validate().then(async (success) => {
        if (!success) return;
        await this.UPDATE_PATCH_APPLICATION_FOR_BRIGADE_WORKS({
          status_unique: this.statusDeniedOrWaiting,
          status_description: this.statusComment2,
          fine: this.fine.toString().replace(/,/g, ''),
          id: this.statusId,
        }).then(() => {
          this.refresh();
          this.$_okToast("success");
          this.$refs.supervisorCommentAndFine.hide()
        });
      })
    },
    // ===============  ON_CHANGE_STATUS_SECTION END ===============








  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
